import { Component, OnInit, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CommonModule } from '@angular/common';

import { UdcsService } from '../../Service/udcs-service';
import { ToastService } from '../../Service/toast-service';

import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
  selector: 'app-udc-edit',
  standalone: true, 
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './udc-edit.html',
  styleUrl: './udc-edit.css',
})
export class UdcEdit implements OnInit {
  editForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<UdcEdit>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private udcService: UdcsService,
    private toastService: ToastService
  ) {}

  ngOnInit(): void {
    this.editForm = this.fb.group({
      id: [this.data.id],
      udcSystem: [{ value: this.data.udcSystem, disabled: true }], // Llaves JDE congeladas por integridad
      udcKey: [{ value: this.data.udcKey, disabled: true }],
      description: [this.data.description, [Validators.required, Validators.maxLength(255)]],
      strValue1: [this.data.strValue1],
      strValue2: [this.data.strValue2],
      booleanValue: [this.data.booleanValue]
    });
  }

  onSave(): void {
    if (this.editForm.invalid) {
      this.editForm.markAllAsTouched();
      this.toastService.showDanger('Captura Inválida', 'La descripción del catálogo no puede ir vacía.');
      return;
    }

    const rawValue = this.editForm.getRawValue();

    const payload = {
      id: rawValue.id,
      udcSystem: rawValue.udcSystem,
      udcKey: rawValue.udcKey,
      description: rawValue.description.trim().toUpperCase(),
      strValue1: rawValue.strValue1?.trim().toUpperCase() || null,
      strValue2: rawValue.strValue2?.trim().toUpperCase() || null,
      booleanValue: rawValue.booleanValue
    };

    console.log('Despachando actualización de catálogo UDC:', payload);

    // Conexión PUT a tu API de Java (Asumiendo que implementamos un método updateUdc en tu servicio)
    // De forma ordinaria si no está creado, puedes re-utilizar tu createUdc ya que Spring Boot con save() 
    // reconoce el ID existente y aplica un UPDATE atómico en MySQL
    this.udcService.createUdc(payload as any).subscribe({
      next: () => {
        this.dialogRef.close(payload);
      },
      error: (err) => {
        console.error(err);
        this.toastService.showDanger('Fallo de Persistencia', 'La base de datos rechazó la modificación.');
      }
    });
  }
}